import React, { Component } from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import styled from 'styled-components';

// icon imports
import DeleteIcon from '@material-ui/icons/Delete';

// table imports
import { withStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

// material ui pickers
import MomentUtils from '@date-io/moment';

import {
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

// material ui core imports
import {
  CircularProgress,
  Button,
  IconButton,
  Grid
} from '@material-ui/core';

// component imports
import {
  RegularCard,
  ItemGrid,
  CustomInput,
} from "../../components";

// reducer imports
import {
  loadShard,
  setShard,
  createNewShard,
  editShard,
  deleteShard
} from './reducer/actions';

import { Redirect } from "react-router-dom";

// modal styles
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 20px;
  border-bottom: 1px solid rgba(153, 153, 153, 0.7);
`
const ModalContent = styled.div`
  position: relative;
  padding: 20px 20px;
  overflow: hidden;
  padding-bottom: 20px;
  line-height: 50px;
`
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid rgba(153, 153, 153, 0.7);
`
// modal style sheets
const customModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 102, 128, 0.5)'
  },
  content: {
    top: 'calc(50% + 30px)',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px !important',
    width: '572px'
  }
};

// custom table cell for table of Shard
const CustomTableCell = withStyles(theme => ({
  head: {
    textAlign: 'center'
  },
  body: {
    fontSize: 16,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '230px',
  },
}))(TableCell);

// theme styles
const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 730,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

// You Podlings should feel proud.
// Only the Emperor is allowed to drink your vital essence.

// class declaration
// Shards - as in a sharded database
class Shards extends Component {

  // constructor
  constructor (props) {
    super(props);

    this.state = {
      name: '', // name of the School being added/edited
      url: '', // its database's URL
      id: null, // its generated ID

      showModal: false, // open the modal that enables creating/editing
      isEditing: false, // if false, adding new
      editingId: '' // ID of the edited School/DB
    };
  }

  // when loading in, load Shards
  componentDidMount() {
    this.props.loadShard();
  }

  // on successful create/edit, close modal
  _onSuccess () {
    this.setState({ showModal: false });
  }

  // on unsuccessful create/edit, close modal and log error
  _onError (error) {
    this.setState({ showModal: false });
    console.log(error);
  }

  // send to reducer Delete Shard function
  _onDeleteShard (id) {
    this.props.deleteShard(
      id, this._onSuccess.bind(this),
      this._onError.bind(this));
  }

  // called when opening the Modal to Edit a Shard
  initEditShard (id) {
    const { allShard } = this.props;
    const curShard = allShard.filter(shard => (shard.id === id))[0];
    // get the proper piece of shard to edit
    // and then set the state of the modal accordingly
    this.setState({
      name: curShard.name,
      url: curShard.url,
      id: curShard.id,
      isEditing: true,
      editingId: id,
      showModal: true
    });
  }

  // called when the modal's Edit button is pressed
  _onEditShard (id) {
    //const { allShard } = this.props;
    // set the properties of the edited Shard
    this.props.editShard(id, {
      name: this.state.name,
      url: this.state.url,
      id: id
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // called on pressing Create on the modal
  _onCreateNewShard () {
    // Hash Generation - simple Hash creation that allows
    // identification of players and games for each league
    var hash = require('object-hash');
    const id = hash(this.state.url);
    alert(this.state.url);

    this.props.createNewShard({
      name: this.state.name,
      url: this.state.url,
      id: id,
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // on showing the modal to Create a new Shard,
  // all the modal fields should be blank
  _onShowModal () {
    this.setState({
      name: '',
      url: '',
      showModal: true
    })
  }
  // close the modal
  _onCloseModal () {
    this.setState({ showModal: false });
  }

  // render function
  render() {
    // make sure only authorized Users proceed
    // check for admin rights in general
    if (!this.props.user.hasOwnProperty('admin')) {
      return (
        <Redirect from={'schools'} to={'dashboard'} key={'invalid'} />
      );
    }
    // check for rights for this page in particular
    // only Superusers can view this page
    if (!this.props.user.admin.master)
    {
      return (
        <Redirect from={'schools'} to={'dashboard'} key={'noTicket'} />
      );
    }

    // classes contains the Classes styles from up top
    const { classes, allShard, isLoading } = this.props;

    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
      <RegularCard
        cardTitle="School Databases"
        cardSubtitle="Names and URLs for Schools"
        content={
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                {/*Top row of content descriptors */}
                <CustomTableCell>
                  {/* Intentionally left blank */}
                </CustomTableCell>
                {/* Name of the School */}
                <CustomTableCell>
                  Name
                </CustomTableCell>
                {/* School's Firebase Database URL */}
                <CustomTableCell>
                  URL
                </CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* If still loading,
                display an empty table with a loading swirly */}
              {isLoading &&
                <TableRow>
                  <TableCell colSpan={6}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              }
              {/* Otherwise, display rows of added Shard */}
              {!isLoading && !isEmpty(allShard) && allShard
                /*.sort((a, b) => moment(a.date).diff(moment(b.date)))*/
                .map((n, id) => {
                  return (
                    <TableRow key={id} className={classes.row}>
                      {/* ID number field */}
                      <CustomTableCell component="th" scope="row">
                        {/* Intentionally left blank */}
                      </CustomTableCell>
                      {/* Shard name field */}
                      <CustomTableCell>
                        {n.name}
                      </CustomTableCell>
                      {/* Shard subtitle field */}
                      <CustomTableCell>
                        {n.url}
                      </CustomTableCell>
                      {/* Featured, Edit, Delete,
                        Move Up, and Move Down buttons */}
                      <CustomTableCell style={{display: 'flex'}}>
                        {/*
                        <IconButton tooltip="Edit Shard"
                          onClick={(e) => {this.initEditShard(n.id)}}>
                          <EditIcon />
                        </IconButton>
                        */}
                        <IconButton tooltip="Delete Shard"
                          onClick={(e) => {this._onDeleteShard(n.id)}}>
                          <DeleteIcon />
                        </IconButton>
                      </CustomTableCell>
                    </TableRow>
                    );
                  }
                )
              }
              {/* after rendering all the Shard, display Add Shard button */}
              <TableRow>
                <TableCell colSpan={6}>
                  <Button style={{background: '#E5e5e5'}}
                    onClick={this._onShowModal.bind(this)}>
                    Add School
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
            {/* end of page table, start of Create/Edit modal */}
            {this.state.showModal &&
              <ReactModal isOpen={this.state.showModal}
                onRequestClose={this._onCloseModal.bind(this)}
                closeTimeoutMS={450}
                contentLabel={this.state.isEditing ? 'Edit School' : 'Add School'}
                ariaHideApp={false}
                style={customModalStyles}
                >
                <ModalHeader>
                  {this.state.isEditing ? 'Edit School' : 'Add School'}
                </ModalHeader>
                <ModalContent>
                  <Grid container>
                    <ItemGrid xs={6}>
                      {/* Set the School Name */}
                      <CustomInput
                        labelText='Name'
                        id='name'
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          value: this.state.name,
                          onChange: (e)=>this.setState({ name: e.target.value })
                        }}
                      />
                    </ItemGrid>
                    <ItemGrid xs={6}>
                      {/* Set the School URL */}
                      <CustomInput
                        labelText='Database URL'
                        id='url'
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          value: this.state.url,
                          onChange: (e)=>this.setState({ url: e.target.value })
                        }}
                      />
                    </ItemGrid>
                  </Grid>
                </ModalContent>
                <ModalFooter>
                  {/* Confirm create/edit */}
                  <Button variant='raised'
                    primary={true}
                    onClick={(e) =>
                      {this.state.isEditing ?
                        this._onEditShard(this.state.editingId)
                        : this._onCreateNewShard()} }>
                    {this.state.isEditing ? 'Edit' : 'Create'}
                  </Button>
                  {/* or just cancel */}
                  <Button variant='raised'
                    style={{ marginLeft: 20 }}
                    onClick={(e) =>
                      {this.setState({ isEditing: false, showModal: false })}}>
                    Cancel
                  </Button>
                </ModalFooter>
              </ReactModal>
            }
          </Table>
          }
      />
      </MuiPickersUtilsProvider>
    );
  }
} // end of class declaration

Shards.propTypes = {
  classes: PropTypes.object.isRequired,
};

//state.shardReducer.shard
//state.shardReducer.isLoading
const mapStateToProps = state => ({
  allShard: state.shardReducer.shard,
  isLoading: state.shardReducer.isLoading,
  user: state.authReducer.user,
  loggedIn: state.authReducer.loggedIn,
});

const mapDispatchToProps = {
  loadShard,
  setShard,
  createNewShard,
  editShard,
  deleteShard,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Shards));
